var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeploymentMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14092_20337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 27H16V29H24V27Z",
    fill: "#0066B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21H20V23H28V21Z",
    fill: "#0066B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 21L30 15L28 15L28 23C29.1046 23 30 22.1046 30 21Z",
    fill: "#0066B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.071 10.7573L20.3137 14L21.7279 12.5858L16.0711 6.92892L10.4142 12.5858L11.8284 14L15.0711 10.7573L15.0711 20.0711H17.071V10.7573Z",
    fill: "#0066B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 3H4C2.8972 3 2 3.8975 2 5V21C2 22.1025 2.8972 23 4 23H12V27H8V29H20V21H4V5H28V19H30V5C30 3.8975 29.1028 3 28 3ZM18 27H14V23H18V27Z",
    fill: "#0066B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14092_20337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploymentMonitoring);
export default __webpack_public_path__ + "static/media/Deployment Monitoring.7ebb9a055a382a8397dcf9dee94d2285.svg";
export { ForwardRef as ReactComponent };